<!--
 Copyright 2024 Google LLC.

 Licensed under the Apache License, Version 2.0 (the "License");
 you may not use this file except in compliance with the License.
 You may obtain a copy of the License at

     https://www.apache.org/licenses/LICENSE-2.0

 Unless required by applicable law or agreed to in writing, software
 distributed under the License is distributed on an "AS IS" BASIS,
 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 See the License for the specific language governing permissions and
 limitations under the License.
-->

<form [formGroup]="fieldValueForm">
  <mat-form-field class="new-exp-form-field">
    <mat-label>{{fieldLabel}}</mat-label>
    <input matInput type="number" [value]="defaultValue" [step]="step" [min]="minVal" [max]="maxVal"
      formControlName="fieldValue" (input)="sendModifiedForm()"/>
    <mat-error
      *ngIf="fieldValue == null" i18n>{{fieldLabel}} is mandatory.</mat-error>
    <mat-error *ngIf="isValueOutOfBound()" i18n
      >{{fieldLabel}} must be between {{minVal}} and {{maxVal}}.</mat-error>
    <mat-error *ngIf="fieldMustBeInteger && isNotInteger()" i18n
      >{{fieldLabel}} must be an integer.</mat-error>
    <mat-error
      *ngIf="getFirstErrorDueToAdditionalConstraints() as errorMessage">{{errorMessage}}</mat-error>
  </mat-form-field>
</form>